module.exports = __webpack_public_path__ + "img/undraw_starry_window_ppm0.74b9f6de.svg";